import React, { Component, useState } from 'react';
import { makeStyles } from "@material-ui/styles";
import { Grid, Typography } from '@material-ui/core';

import { Mobile, NotMobile } from 'utils';
import StatusTable from 'Components/StatusTable';
import theme from 'Theme';
import { getAllCompanyDataAggregated } from './API/Company';

let dateFormat = require("dateformat");

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#E9EFF6",
  },
  appBarSpacer: theme.mixins.toolbar,
  topTextContainer: {
    padding: theme.spacing(9, 0),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(5, 1),
    },
  },
  topText: {
    fontWeight: 300,
    marginBottom: 32,
  },
  topTextDetail: {
    fontWeight: 400,
  },
  formContainer: {
    marginTop: "50px",
  },
  sourceLink: {
    textTransform: "none",
    textDecoration: "none",
  },
  padTopBottom: {
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(5),
  },
  table_header: {
    fontSize: "35px"
  },
  container: {
    height: "100vh",
    maxHeight: "1900px"
  },
  goHome: {
    fontSize: "40px",
    marginBottom: "20px"
  },
  '@media (min-width: 768px)': {
    container: {
      marginTop: "30px"
    }
  },
  '@media (max-width: 767px)': {
    table_header: {
      marginBottom: "20px"
    },
    container: {
      width: "100% !important",
      marginTop: "0 !important"
    }
  }
}));



export default function MainTable( { fullscreen } ) {
const classes = useStyles();
const [loading, setLoading] = useState(false);
const [hasData, setHasData] = useState(false);
const [data, setData] = useState([]);
const [error, setError] = useState(false)

const maxWidth = fullscreen ? 1600 : 1240;
const otherVal = fullscreen ? { margin: "auto", marginTop: "50px", height: "unset" } : null;

const headCells = [
    {
      id: "companyName",
      label: (
        <div>
          <Typography style={{ color: theme.palette.info.main, fontSize: 14 }}>
            Company
          </Typography>
        </div>
      ),
    },
    {
      id: "status",
      label: (
        <div>
          <Typography style={{ color: theme.palette.info.main, fontSize: 14 }}>
            Remote Policy
          </Typography>
        </div>
      ),
    },
    {
      id: "hq",
      label: (
        <Typography style={{ color: theme.palette.info.main, fontSize: 14 }}>
          HQ
        </Typography>
      ),
    },
    {
      id: "numEmployees",
      label: (
        <Typography style={{ color: theme.palette.info.main, fontSize: 14 }}>
          # of Employees
        </Typography>
      ),
    },
    {
      id: "jobsLink",
      label: (
        <Typography style={{ color: theme.palette.info.main, fontSize: 14 }}>
          Jobs Page
        </Typography>
      ),
    },
    {
      id: "source",
      label: (
        <Typography style={{ color: theme.palette.info.main, fontSize: 14 }}>
          Sources
        </Typography>
      ),
    },
  ];  

const getStatus = (isPermanent, remoteUntil, indefinite) => {
  if (isPermanent) {
    return <b>Permanent</b>;
  } else if (indefinite) {
    return "Indefinite";
  } else if (
    !isPermanent &&
    remoteUntil.toDate().getTime() > new Date().getTime()
  ) {
    return "Current";
  } else {
    return "No Longer Remote";
  }
}  

const getRemoteSinceResult = (remoteSince) => {
  if (!remoteSince || !remoteSince.toDate) {
    return "-";
  }
  if (remoteSince.toDate().getTime() === new Date("1991-08-06").getTime()) {
    return "Always";
  } else if (remoteSince) {
    return dateFormat(remoteSince.toDate(), "mmm d, yyyy");
  } else {
    return "-";
  }
}

const getRemoteUntilResult = (isPermanent, remoteUntil) => {
  if (isPermanent) {
    return "-";
  } else {
    return dateFormat(remoteUntil.toDate(), "mmm d, yyyy");
  }
}

const getSource = (source) => {
  if (source.toLowerCase() === "internal email") return "Internal Email";

  let url = "";
  try {
    url = new URL(source);
  } catch (e) {
    return <span style={{ textTransform: "capitalize" }}>source</span>;
  }

  if (url.hostname.substring(0, 4) === "www.") {
    url.hostname = url.hostname.substring(4);
  }

  return (
    <a
      href={source}
      target="_blank"
      className={classes.sourceLink}
    >
      {url.hostname}
    </a>
  );
}  

const getJobsLink = (source) => {
  let url = "";
  try {
    url = new URL(source);
  } catch (e) {
    return <span style={{ textTransform: "capitalize" }}>Not Available</span>;
  }

  // Prettify
  if (url.hostname.substring(0, 4) === "www.") {
    url.hostname = url.hostname.substring(4);
  }

  return (
    <a
      href={source}
      target="_blank"
      className={classes.sourceLink}
    >
      {url.hostname.includes("jobs") || url.hostname.includes("careers")
        ? `${url.hostname}`
        : `${url.hostname}/jobs`}
    </a>
  );
} 

const getTableData = async () => {
  let data = null;
  for (let i = 0; i < 3; i++) {
    try {
      data = await fetchData();
    } catch (error) {
      console.log("error: ", error);
    }
  }

  if (data && data.length === 0) {
  
    setError(true)

  }
  return data;
}

const fetchData = async () => {
  let maxDate = {};

  const companyData = await getAllCompanyDataAggregated();

  const createTableRow = (companyName) => {
    let {
      companyName: name,
      remoteSince,
      remoteUntil,
      source,
      perm: isPermanent,
      remotePolicy,
      policyDuration,
      companyInfo,
      jobsLink,
    } = maxDate[companyName];

    if (remotePolicy) {
      if (remotePolicy === "fully-distributed") {
        remotePolicy = "Fully Distributed";
      } else if (remotePolicy === "remote-first") {
        remotePolicy = "Remote-First";
      } else if (remotePolicy === "remote-friendly") {
        remotePolicy = "Remote-Friendly";
      } else {
        remotePolicy = "Temporarily Remote";
      }
    } else {
      remotePolicy = "Not Defined";
    }

    let statusRes = getStatus(isPermanent, remoteUntil);
    let remoteSinceRes = getRemoteSinceResult(remoteSince);
    let remoteUntilRes;

    if (remoteSinceRes === "Always") {
      remoteUntilRes = "-";
      statusRes = getStatus(true, null);
    } else {
      remoteUntilRes = getRemoteUntilResult(isPermanent, remoteUntil);
    }

    if (policyDuration && policyDuration === "indefinite") {
      remoteUntilRes = "Indefinite";
    }

    return {
      name,
      status: remotePolicy,
      remoteSince: remoteSinceRes,
      remoteUntil: remoteUntilRes,
      source: getSource(source),
      numEmployees: companyInfo?.companyData?.employees || "",
      jobsLink: getJobsLink(jobsLink || ""),
      hq: companyInfo?.companyData?.HQ || "",
      logo: companyInfo?.companyData?.icon?.logo || "",
    };
  };

  let processList = (entry, index) => {
    if (
      !entry.companyName ||
      !entry.verified ||
      getStatus(entry.perm, entry.remoteUntil, entry.policyDuration) ===
        "No Longer Remote"
    ) {
      return;
    }

    const { companyName: name } = entry;

    if (
      maxDate[name] &&
      maxDate[name].submissionDate < entry["submissionDate"]
    ) {
      maxDate[name] = entry;
    } else if (!maxDate[name]) {
      maxDate[name] = entry;
    }
  };


  companyData.forEach(processList);

  const tableData = Object.keys(maxDate).map(createTableRow);

  setData(tableData)
  setLoading(false)
  setHasData(true)


  return tableData;
}; 


if ((!loading && !hasData && !error) || loading) {
  if (!loading) {
    
    setLoading(true, getTableData())
   
  }

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      style={{ width: "calc(100vw - 40px", maxWidth, ...otherVal }}
      className={classes.container}
    > 
      <div id="table"></div>
      <StatusTable
          headCells={headCells}
          rows={[]}
          loading
          searchBarEnabled
          fullscreen={!fullscreen}
          dense
      />
    </Grid>
  );
}          

return (
<>
  <Mobile>
    <Grid
        container
        direction="column"
        alignItems="center"
        style={{ width: "calc(100vw - 40px", maxWidth, ...otherVal }}
        className={classes.container}
    >
        <div id="table"></div>
        <StatusTable
            headCells={headCells}
            rows={data}
            searchBarEnabled
            fullscreen={!fullscreen}
            dense
        />                    
    </Grid>
  </Mobile>
  <NotMobile>
    <Grid
        container
        direction="column"
        alignItems="center"
        style={{ width: "calc(100vw - 40px", maxWidth, ...otherVal, marginBottom: "20px" }}
        className={classes.container}
        id="table"
    >
        <div id="table"></div>
        <StatusTable
            headCells={headCells}
            rows={data}
            searchBarEnabled
            fullscreen={!fullscreen}
            dense
        />                    
    </Grid>
  </NotMobile>
</>
)
}

